<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';

export default {
  components: { swiper, swiperSlide, Slick },

  data() {
    const $self = this;
    const DEFAULT_PAGE_COUNT = 1;
    return {
      list: [
        {
          title: '櫃檯管理',
          icon: 'calender',
          content: {
            img1: require('@assets/images/adminImgs/home_calandar.png'),
            // img2: require('@assets/images/adminImgs/home_calandar.png'),
            text: '快速瀏覽預約排程！可即時新增、更新訂單，同時有「報到」、「簽名確認」和「加購服務」的功能，分配任務並掌控工作排程變得更容易，讓服務能有效率地傳遞，助於提供優質的服務體驗。',
          }
        },
        {
          title: '排班管理',
          icon: 'time',
          content: {
            img1: require('@assets/images/adminImgs/home_sechedle.png'),
            // img2: require('@assets/images/home/section2-image-shadow@2x.png'),
            text: '每次排班總是前改後改8遍，班表跟您的煩惱一樣亂糟糟嗎？i寵訂清楚的排班規劃功能，讓您輕鬆完成，隨時修改班表也不擔心！',
          }
        },
        {
          title: '包月方案',
          icon: 'plan',
          content: {
            img1: require('@assets/images/adminImgs/home_plan.png'),
            // img2: require('@assets/images/home/section2-image-shadow@2x.png'),
            text: '預約使用方案抵扣，皆有客戶簽名確認。明定方案有效期限，可提醒客戶於過期前使用完畢。',
          }
        },
        {
          title: '儲值金功能',
          icon: 'dollar',
          content: {
            img1: require('@assets/images/adminImgs/home_deposit.png'),
            // img2: require('@assets/images/home/section2-image-shadow@2x.png'),
            text: '輕鬆自訂儲值金方案，還可以應用加入會員的會費設定，讓業務運轉更多可能！',
          }
        },
        {
          title: '數據分析',
          icon: 'data',
          content: {
            img1: require('@assets/images/adminImgs/home_data.png'),
            // img2: require('@assets/images/home/section2-image-shadow@2x.png'),
            text: '具備了訂單收益、人力物力營運的統計數據報告。為您追蹤業務績效並比較不同時期的收入報告，了解您最受歡迎的服務、最忠實的客戶，以理性的數據讓您在調整服務方向、或推行行銷方案時更有跡可循，大幅提高經濟效益。',
          }
        },
        {
          title: '安親服務',
          icon: 'daycare',
          content: {
            img1: require('@assets/images/adminImgs/interface06@1.png'),
            // img2: require('@assets/images/adminImgs/home_calandar.png'),
            text: '加贈安親模組，可以針對安親進行服務設定與管理，大幅增加寵物產業多元化的服務！',
          }
        },
      ],
      activeIndex: 0,
      isActive: 0,
      swiperOption: {
        slidesPerView: 6,
        speed: 1200,
        direction: 'vertical',
        slidesPerGroup : 1,
        spaceBetween: 30,
        // // centeredSlides: true,
        // // shortSwipes : false,
        allowTouchMove: false,
        height: 450,
        initialSlide: DEFAULT_PAGE_COUNT - 1,
        on: {
          slideChange () {
            const index = ( this.activeIndex % $self.list.length ) || 0;
            $self.setSlide(index)
          }
        },
        breakpoints: {       
          // 320: {       
          //   slidesPerView: 1,
          //   spaceBetween: 10     
          // },          
          // 770: {       
          //   direction: 'horizontal',
          // },   
          766: {
            allowTouchMove: true,
            slidesPerView: 3,
            direction: 'horizontal',  
          },
          1199: {
            spaceBetween: 0,       
            slidesPerView: 6,       
            direction: 'horizontal',  
          } 
        }   
      },
      swiperOptionEvent: {
        direction: 'vertical',
        height: 750,
        slidesPerView: 1,
        autoHeight: true,
        allowTouchMove: false,
        breakpoints: {       
          1199: {
            height: 600,
            spaceBetween: 30,     
            direction: 'horizontal',  
          } 
        }   
      },
      
    }
  },
  methods: {
    setSlide(index) {
      this.isActive = index;
      this.$refs.carouselTitle.swiper.slideTo(index, 1200)
      this.$refs.carouselEvent.swiper.slideTo(index, 1200)
    },
    onNext() {
      this.$refs.carouselTitle.swiper.slideNext()
    },
    onPrev() {
      // this.$refs.carouselTitle.swiper.slidePrev()
    },
  },
}
</script>

<template>
  <section :class="$style.sectionFeatures">
    <div sectionFeatures__bg></div>
    <div class="container section">
      <div class="sectionFeatures__Inner">
        <BaseSectionTitle 
          title="預約系統方案" 
          sub-title="Reservation System" 
          class="isStyleDecoration text-center isCenter mx-auto"
        />
        <div class="sectionFeatures__carousel">
          <div class="row flex-xl-row-reverse">
            <div class="col-xl-4 pt-xl-3">
              <div class="carouselTitle">
                <swiper
                  ref="carouselTitle"
                  :options="swiperOption"
                  class="carouselTitle__list"
                  :breakpoints="swiperOption.breakpoints"
                >
                  <swiper-slide
                    v-for="(item, $index) in list"
                    :key="$index"
                    class="carouselTitle__item"
                    :class="{ isActive: isActive === $index }"
                  >
                    <div 
                      class="carouselTitle__item--boxInner" 
                      @click="setSlide($index)" 
                      @keydown="setSlide($index)"
                    >
                      <span class="icon text-center">
                        <i :class="`icomoon icon-${item.icon}`"></i>
                      </span>
                      <span class="title">{{item.title}}</span>
                    </div>
                  </swiper-slide>
                </swiper>
                <div class="navigationBox">
                  <button class="navigationBtn isNext" @click="onNext">
                    <i class="icomoon icon-arrow-button"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-xl-8 mt-xl-0 mt-5 carouselEvent">
                <swiper
                  ref="carouselEvent"
                  :options="swiperOptionEvent"
                  class="carouselEvent__list "
                >
                  <swiper-slide
                    v-for="(contentItem, $index) in list"
                    :key="$index"
                    class="carouselEvent__item"
                  >
                    <div
                      class="carouselEvent__item--boxInner text-center" 
                    >
                      <img 
                        :src="contentItem.content.img1" 
                        class="img"
                        alt=""
                      >
                      <div class="content mx-xl-auto mx-auto color-text-2">
                        <p class="mb-0">{{contentItem.content.text}}</p>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
            </div>
          </div>
        </div> 
      </div>
    </div>
  </section>
</template>

<style lang="scss" module>
  .sectionFeatures {
    // padding-top: 190px;
    position: relative;
    &:before {
      content:'';
      position: absolute;
      bottom:-5%;
      background-image: url('@assets/images/home/section3-bg.svg');
      padding-bottom: 39%;
      background-repeat: no-repeat;
      background-size: cover;      
      width: 100vw;
      left: 0;
      @include max-lg {
        bottom: 1%;
        background-position: 0;
      }
      // @include max-md {
      //   bottom: -9%;
      //   background-position: 25%;
      // }
      // @include max-xl {
      //   padding-bottom: 0;
      //   height: 100%;
      // }
    }
    :global {
      .sectionFeatures {
        &__Inner {
          
        }
        &__carousel {
          // margin-top: 60px;
          &--carouselTitle {
            @include max-md {
              // display: flex;
            }
          }
          .carouselTitle {
            @include max-xl {
              position: relative;
              &:before {
                content: '';
                position: absolute;
                height: 2px;
                right: 0;
                left: 0;
                bottom: 0;
                transform: none;
                background-color: $color-line;
              }
            }
            &__item {
              &--boxInner {
                padding-left: 55px;
                margin-left: 25px;
                cursor: pointer;
                @include max-xl {
                  padding-left:0;
                  margin-left: 0; 
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  padding-bottom: 10px;
                }
                @include max-md {
                  display: flex;
                }
                .icon {
                  display: inline-block;
                  line-height: 60px;
                  height: 60px;
                  width: 60px;
                  border-radius: 50%;
                  background: rgba($color: #F5F7F8, $alpha: 1.0);
                  color: $color-text-3;
                  font-size: 29px;
                  letter-spacing: 0;
                  transition: .3s;
                  @include max-xl {
                    display: block;
                  }
                  @include max-md {
                    height: 40px;
                    width: 40px;
                    line-height: 40px;
                    font-size: 20px;
                  }
                }
                .title {
                  font-size: 20px;
                  font-weight: 600;
                  margin-left: 20px;
                  transition: .3s;
                  @include max-xl {
                    margin-left: 0;
                    margin-top: 5px;
                  }
                  @include max-md {
                    font-size: 15px;
                  }
                }
              } 
            }
            .navigationBox {
              max-width: 100px;
              height: 30px;
              margin-left: auto;
              align-self: center;
              margin-top: -20px;
              display: none;
              @include max-md {
                display: block;
              }
              @include max-sm {
                 
              }
              .navigationBtn {
                color: $color-text-3;
                background: transparent;
                border: 1px solid $color-text-3;
                border-radius: 100px;
                width: 32px;
                height: 32px;
                display: block;
                letter-spacing: 0;
                padding-left: 2px;
                padding-right: 2px;
                &:focus {
                  outline: none;
                }
                &:active {
                  color: $color-primary;
                  opacity: 0.5;
                }
              }
            }
            .swiper-slide {
              &.isActive {
                .carouselTitle__item {
                  &--boxInner {
                    .icon {
                      background: rgba($color: $color-primary, $alpha: 0.15);
                      color: $color-primary;
                    }
                    .title {
                      color:$color-primary;
                    }
                    position: relative;
                    &:before {
                      position: absolute;
                      content: url('~@assets/images/home/arrow.svg');
                      left: -20px;
                      top: 50%;
                      transform: translateY(-50%);
                      @include max-xl {
                        content: '';
                        height: 2px;
                        right: 0;
                        left: 0;
                        top: auto;
                        bottom: 0;
                        transform: none;
                        background-color: $color-primary;
                      }
                    }
                  } 
                }
              }
            }
            @include max-md {
              display: flex;
            }
          }
          .carouselEvent{
            &__item {
              &--boxInner {
                padding-left: 15px;
                padding-right: 15px;
                .img {
                  border-radius: 10px;
                  box-shadow: 0px 5px 20px rgba(40, 45, 78, 0.2);
                  max-width: 820px;
                  margin-bottom: 20px;
                  margin-top: 20px;
                  width: 100%;
                  @include max-xl {
                    max-width: 100%;
                  }
                }
                .content {
                  margin-bottom: 50px;
                  max-width: 829px;
                  margin-left: 30px;
                  margin-right: 30px;
                  padding: 32px 89px;
                  background-color: rgba($color: #fff, $alpha: 0.32);
                  border-radius: 10px;
                  backdrop-filter: blur(6px);
                  box-shadow: 0px 3px 24px rgba(0, 0, 0, 0.16);
                  @include max-xl {
                    max-width: 100%;
                  }
                  @include max-lg {
                    padding: 18px 20px;
                    margin-top: 20px;
                  }
                  @include max-md {
                    font-size: 14px;
                    box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.16);
                  }
                  // position: relative;
                  // overflow: hidden;
                  // &:before {
                  //   content: '';
                  //   position: absolute;
                  //   top: 0;
                  //   left: 0;
                  //   bottom: 0;
                  //   right: 0;
                  //   backdrop-filter: blur(6px) opacity(20%);;
                  //   background-color: #ffffff
                  // }
                  p {
                    // position: relative;
                    // z-index: 2;
                    
                  }
                }
              }
            }
            &__List {
              .swiper-container {
                width: 100%;
                height: 100%;
                margin-left: auto;
                margin-right: auto;
              }
            }
          }
        }
      }
    }
  }
</style>